"use client";

import Link from "next/link";
import Image from "next/image";
import { Box, Text, Button, Group, Stack } from "@mantine/core";
import { IconArrowRight } from "@tabler/icons-react";
import { PROMOTE_STYLE_CLUB } from "@/lib/websiteOffers";
import { PRICING } from "@/constants/pricing";

// Editorial Style Club promo card. Deliberately secondary to the AI color
// analysis offers — always place BELOW the primary analysis/bundle CTA.
export default function StyleClubCard({ season }: { season?: string }) {
  if (!PROMOTE_STYLE_CLUB) return null;
  return (
    <Box
      style={{
        background: "var(--mantine-color-violet-0)",
        borderTop: "3px solid #141414",
        borderRadius: "var(--mantine-radius-lg)",
        overflow: "hidden",
      }}
    >
      <Group gap={0} wrap="nowrap" align="stretch">
        <Box
          visibleFrom="xs"
          style={{ position: "relative", width: 132, minWidth: 132, alignSelf: "stretch", minHeight: 150 }}
        >
          <Image
            src="/season-outfits/soft-autumn/outfit-2.webp?v2"
            alt="AI outfit illustration for Style Club"
            fill
            sizes="132px"
            style={{ objectFit: "cover" }}
          />
        </Box>
        <Stack gap={6} p="md" justify="center" style={{ flex: 1 }}>
          <Text fz={10} tt="uppercase" c="dimmed" style={{ letterSpacing: 2 }}>
            Style Club &nbsp;·&nbsp; First 7 days free
          </Text>
          <Text fw={500} fz="md" lh={1.3} style={{ letterSpacing: -0.2 }}>
            {season ? (
              <>
                Three new {season} outfits,{" "}
                <Text span inherit fs="italic" c="dark.4">
                  every week
                </Text>
              </>
            ) : (
              <>
                A personal stylist,{" "}
                <Text span inherit fs="italic" c="dark.4">
                  on your phone
                </Text>
              </>
            )}
          </Text>
          <Text fz="xs" c="dimmed" lh={1.5}>
            Three outfit ideas every week in your colors, plus 100 AI stylist messages a month. Use your closet, plan an occasion, or get outfit feedback.
            ${PRICING.STYLE_CLUB.MONTHLY_PRICE}/mo after your free week — cancel anytime.
          </Text>
          <Button
            component={Link}
            href="/style-club"
            color="violet"
            size="xs"
            w="fit-content"
            mt={2}
            rightSection={<IconArrowRight size={12} />}
          >
            Meet your stylist
          </Button>
        </Stack>
      </Group>
    </Box>
  );
}
